import { FC, MouseEvent, useCallback } from 'react';
import cn from 'classnames';

import './Button.scss';

type ButtonProps = {
    label: string;
    style?: {
        [key: string]: any;
    };
    'data-id'?: string;
    disabled?: boolean;
    withBorder?: boolean;
    invertedColors?: boolean;
    selected?: boolean;
    'data-tour'?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
    className?: string;
    image?: any;
};

const Button: FC<ButtonProps> = ({
    disabled,
    label,
    style,
    'data-id': dataId,
    onClick,
    withBorder,
    invertedColors,
    'data-tour': dataTour,
    selected,
    className,
    image
}) => {
    const handleClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            if (disabled) return;
            onClick && onClick(e);
        },
        [disabled, onClick],
    );

    return (
        <div
            className={cn('button', {
                button_disabled: disabled,
                button_selected: selected,
                'button_with-border': withBorder,
                'button_inverted-colors': invertedColors,
            }, className)}
            data-id={dataId}
            data-tour={dataTour}
            style={style}
            onClick={handleClick}
        >
            {image && <img src={image} alt="" />}
            <span>{label}</span>
        </div>
    );
};

export default Button;
